import React from 'react'
import { useHistory } from 'react-router-dom'
import cn from 'classnames'
import { useQuery } from '@apollo/client'
import { QUERY } from '../../apollo'
import { RequestForm } from '../Modals/SupervisionModal'

import styles from './detail.module.css'

function AskSupervision() {
  let history = useHistory()
  const { data } = useQuery(QUERY.USER_INFO)
  const userInfo = data?.userInfo

  return (
    <div className={cn(styles.wrapper, styles.expanded)}>
      <div className={cn(styles.content)}>
        <p className={styles.pageTitle}>
          Our professional music team is available to create a custom free song
          selection for you & offer musical supervision for your project.
        </p>
        {userInfo ? (
          <RequestForm
            initialValues={{
              email: userInfo.email,
              name: userInfo.name,
              company: userInfo?.billingInfo.company,
            }}
            callback={({ requestType, requestId }) => {
              history.push(`/profile/${requestType}/${requestId}`)
            }}
            messageTime={500}
            hiddenValues
          />
        ) : null}
      </div>
    </div>
  )
}

export default AskSupervision
